import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '../locales/en.json';
import he from '../locales/he.json';
import fr from '../locales/fr.json';
import es from '../locales/es.json';
import it from '../locales/it.json';

// Normalize and read saved language BEFORE init. Explicit `lng` in init overrides
// the LanguageDetector, so we must set lng from localStorage here to respect user choice.
const SUPPORTED_LNG_CODES = ['he', 'en', 'fr', 'es', 'it'] as const;
let initialLng: string = 'he';
try {
  const savedLang = typeof localStorage !== 'undefined' ? localStorage.getItem('i18nextLng') : null;
  if (savedLang) {
    const lower = savedLang.toLowerCase();
    const matched = SUPPORTED_LNG_CODES.find(
      (code) => lower.startsWith(code) || (code === 'he' && lower.startsWith('iw')),
    );
    if (matched) {
      localStorage.setItem('i18nextLng', matched);
      initialLng = matched;
    } else {
      localStorage.setItem('i18nextLng', savedLang);
      initialLng = savedLang;
    }
  }
} catch {
  // localStorage unavailable (e.g. private mode, SSR)
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      he: { translation: he },
      fr: { translation: fr },
      es: { translation: es },
      it: { translation: it },
    },
    lng: initialLng, // Use saved choice so refresh keeps English when selected
    fallbackLng: 'he',
    supportedLngs: ['en', 'he', 'fr', 'es', 'it'],
    nonExplicitSupportedLngs: true, // so fr-FR / es-ES use fr / es resources
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      caches: [],
    },
  });

// After initialization, ensure the language is one of our supported locales
if (
  i18n.language &&
  !SUPPORTED_LNG_CODES.some(
    (l) => i18n.language?.startsWith(l) || (l === 'he' && i18n.language?.startsWith('iw')),
  )
) {
  i18n.changeLanguage('he');
}

export default i18n;
